import { HttpRequest } from '@angular/common/http/public_api';
import { FileRecordInterface } from '@careapp/angular-sdk';

import * as actions from '../actions/index';

export interface State {
  [id: string]: {
    file: File;
    url: string;
    progress: number;
    cancelled: boolean;
    error: string;
    success: boolean;
    request: HttpRequest<any>;
    response: FileRecordInterface;
  };
}

const initialState: State = {};
export function reducer(state: State = initialState, action: actions.CAAction) {
  switch (action.type) {
    case actions.REQUEST_FILE_UPLOAD_START:
      let { file, url } = action.payload;
      return {
        ...state,
        [action.payload.id]: { file, url, progress: 0, cancelled: false, response: {} }
      };
    case actions.REQUEST_FILE_UPLOAD_CANCEL:
      return { ...state, [action.payload.id]: { ...state[action.payload.id], cancelled: true } };
    case actions.RESPONSE_FILE_UPLOAD_PROGRESS:
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], progress: action.payload.progress }
      };
    case actions.RESPONSE_FILE_UPLOAD_COMPLETE:
      return {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          response: action.payload.response,
          progress: 100,
          success: true
        }
      };
    case actions.RESPONSE_FILE_UPLOAD_ERROR:
      return {
        ...state,
        [action.payload.id]: { ...state[action.payload.id], error: action.payload }
      };
    default:
      return state;
  }
}

export const fileError = (fileId: string) => (state: State) => state[fileId].error;
export const fileProgress = (fileId: string) => (state: State) => state[fileId].progress;
export const fileSuccess = (fileId: string) => (state: State) =>
  state[fileId].progress === 100 && state[fileId].success;
export const fileResponse = (fileId: string) => (state: State) => state[fileId].response;
export const fileRequest = (fileId: string) => (state: State) => state[fileId].request;
